<template>
    <div>
        <van-nav-bar
            title="招标详情"
            left-text="返回"
            left-arrow
            fixed
            @click-left="$router.replace({path:'/',query:{...$route.query}})"
        />
        <div class="bg-light padding" style="padding-top:70px !important;padding-bottom:70px !important;" v-if="info">
            <div class="text-center">{{info.title}}</div>
            <div class="flex flex-row flex-ai flex-jc f12 dark-3 margin-top-40">
                <van-icon name="apps-o" v-if="info.industry"/>{{info.industry ? info.industry.name : ''}}
                <van-icon name="location-o" class="margin-left-20" v-if="info.province_name"/>{{info.province_name}}
                <van-icon name="clock-o"  class="margin-left-20" v-if="info.end_time"/>{{info.end_time}}
            </div>
            <div class="text-center margin-top-30">
                <log-button type="favorite" akey="bids" :tid="id" :is-one="info.is_favorite" class="margin-left-20" style="padding:5px 15px !important;" icon="star-o" title="收藏"></log-button>
            </div>
            <div class="bg-light" style="overflow-wrap: break-word;padding-bottom: 10px;" v-html="info.content" v-if="info.bid_state === 1"></div>
            <div class="cl bg-light" v-if="info.bid_state === 1 && info.files.length > 0">
                <div class="z">附件：</div>
                <div class="z">
                    <a :href="item.url.indexOf('http') >= 0 ? item.url : $config.assetsUrl + item.url" v-for="(item,index) in info.files" target="_blank">{{item.name}}</a>
                </div>
            </div>
            <div v-else-if="!$user.getUid()">
                <div style="margin:50px 50px 0 50px;">
                    <van-button round block color="#144b9e" @click="$router.push({path:'/login'})">登录</van-button>
                    <van-button round block type="info" class="margin-top-20" @click="$router.push({path:'/register'})">注册</van-button>
                </div>
            </div>
            <template v-else>
                <div v-if="info.bid_state === 2">
<!--                    <div style="margin:50px 50px 0 50px;" v-if="info.open_vip_buy === 1">-->
<!--                        <van-button round block type="info" color="#144b9e"  class="margin-top-20" @click="$router.push({path:'/vip'})">成为VIP￥{{info.vip_price[0].price}}起，即可查看详情</van-button>-->
<!--                    </div>-->
<!--                    <div style="margin:50px 50px 0 50px;" v-if="info.is_pay === 1">-->
<!--                        <van-button round block type="info" class="margin-top-20" @click="$router.push({path:'/order/pay/',query:{-->
<!--                            order_type:'bids',-->
<!--                            id:info.id,-->
<!--                            pay_amount:info.price,-->
<!--                            title:info.title,-->
<!--                            uid:($user.getUid() ? $user.getUid() : ''),-->
<!--                            url:($route.query.url ? $route.query.url : '')-->
<!--                        }})">{{info.pay_des ? info.pay_des.replace('{price}',info.price) : setting.pay_btn_text.replace('{price}',info.price)}}</van-button>-->
<!--                    </div>-->
	                <div class="text-center margin-top-20">
		                <img :src="info.mini_qrcode" width="166" class="border-w-1 border-dark-1"/>
		                <div style="margin-top:10px;color:#777;font-size: 14px;" class="text-center">长按上面的二维码，即可查看详情</div>
	                </div>
                    <div v-html="setting.weixin_bids_des" style="margin: 50px 30px 0 30px;"></div>
<!--                    单条支付￥{{info.price}}，即可查看详情-->
<!--                    <div class="text-center dark-2" style="margin: 50px 30px 0 30px;line-height: 30px;">开通会员，可全年免费查看标讯</div>-->
<!--                    <div class="text-center dark-2" style="margin: 0 30px 0 30px;line-height: 30px;">详细信息请致电：<a href="tel://01051607759" class="brand f-b">010-51607759</a>咨询</div>-->
                </div>
            </template>
        </div>
        <div class="bg-light fixed brand border-top" style="bottom:0;left:0;right:0;height:50px;">
            <van-row type="flex" justify="center" style="height:50px;">
                <van-col span="12" class="flex flex-ai flex-jc" @click="toCall"><van-icon name="phone-circle-o" size="18" class="margin-right-5"/>4006 515156</van-col>
                <van-col  @click="showShare = true" v-if="share === 1" span="12" class="flex flex-ai flex-jc success"><van-icon name="wechat"  class="margin-right-5" size="18"/>一键推荐</van-col>
            </van-row>
        </div>
        <van-dialog v-model="showDingyueQrcode" v-if="info" class="text-center">
            <img :src="info.weixin_app_qrcode.indexOf('http') >= 0 ? info.weixin_app_qrcode : $config.assetsUrl + info.weixin_app_qrcode" class="margin-top-20"/>
            <div class="text-center f14 dark-2 padding-top-bottom">长按二维码，关注订阅号，可获得更好的服务</div>
        </van-dialog>
        <van-overlay :show="showShare" @click="showShare = false">
            <div class="margin-top margin-right rel">
                <div class="text-right"><img src="/images/wx3.png" style="vertical-align: middle;" width="40"/></div>
                <div class="text-center light">
                    <div>
                        <span style="display: inline-block;background: #0570db;border:1px solid #fff;width:20px;height:20px;line-height:20px;border-radius: 10px;" class="f12 margin-right">1</span>点击右上角<img src="/images/wx2.png" width="30" style="vertical-align: middle;" class="margin-right margin-left"/>打开菜单
                    </div>
                    <div class="margin-top-20">
                        <span style="display: inline-block;background: #0570db;border:1px solid #fff;width:20px;height:20px;line-height:20px;border-radius: 10px;" class="f12 margin-right vm">2</span>选择<img src="/images/share1.png" height="30" class="margin-right margin-left vm"/> 或 <img src="/images/share2.png" height="30" class="margin-right margin-left vm"/>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk';
export default {
    name: "detail",
    data(){
        return{
            id:'',
            info:null,
            uid:'',
            showDingyueQrcode:false,
            key:'',
            dingyueTime:null,
            showShare:false,
            share:0,
            setting:{
                weixin_bids_des:'',
                pay_btn_text:''
            }
        }
    },
    created() {
        this.id = this.$route.params.id ? this.$route.params.id : '';
        this.key = this.$route.query.key ? this.$route.query.key : '';
        this.$emit('bgColor','#fff');
        this.uid = this.$user.getUid() ? this.$user.getUid() : '';
        this.share = this.$route.query.share ? parseInt(this.$route.query.share) : 0;
    },
    mounted() {
        this.getDetail();
        this.getDes();
    },
    methods:{
        initShare(){
            let _this = this;

            let url = location.href.split('#')[0];
            let _shareurl = 'http://m.clb.org.cn/bids/detail/'+this.info.id;

            let _config = {
                title: '来自你好友的分享', // 分享标题
                link: _shareurl, // 分享链接
                imgUrl: 'http://m.clb.org.cn/images/logo_share.png', // 分享图标
                desc: this.info.title, // 分享描述
                success () {
                    // console.log('fds');
                },
                cancel () {
                    // console.log('fds');
                }
            }
            this.$utils.wxTool(url,function(){
                //分享给朋友
                wx.onMenuShareAppMessage(_config);
                wx.onMenuShareTimeline(_config)
            })
        },
        toCall(){
            let _this = this;
            // this.$dialog.confirm({
            //     title: '提示',
            //     message: '确定拨打电话：4006 515156吗？',
            // }).then(() => {
            //     window.location.href = 'tel://4006515156'
            // }).catch(() => {
            //     // on cancel
            // });
            window.location.href = 'tel://4006515156'
        },
        getDetail(){
            let _this = this;

            if(this.id) {
                this.$http.post({
                    url: 'Bids/detail',
                    data: {id: this.id,key:this.key},
                    success(res) {
                        _this.info = res;

                        // if(res.bid_state >= 1 && res.is_subscribe_dingyue === 0){
                        //     _this.showDingyueQrcode = true;
                        //
                        //     _this.dingyueTime = setInterval(_this.checkDingyue, 3000)
                        // }

                        _this.initShare();
                    }
                })
            }
        },
        getDes(){
            let _this = this;

            if(this.id) {
                let _skeys = [];

                for (let k in this.setting) {
                    _skeys.push(k);
                }

                this.$http.post({
                    url:'SystemSetting/getSystem',
                    data: {skey: _skeys},
                    success(res) {
                        _this.setting = res;
                    }
                })
            }
        },
        checkDingyue(){
            let _this = this;
            this.$http.post({
                url:'/User/checkDingState',
                datas:null,
                success(res){
                    if(res.is_subscribe_dingyue === 1){
                        clearInterval(_this.dingyueTime);
                        _this.dingyueTime = null;
                        _this.showDingyueQrcode = false;
                    }
                }
            })
        },
    },
    destroyed() {
        if(this.dingyueTime) {
            clearInterval(this.dingyueTime);
            this.dingyueTime = null;
        }
    }
}
</script>
